// import 'whatwg-fetch';

function parseJSON(response) {
  // const responseDate = response.headers.get('date');
  return response.json().then(json => ({
    status: response.status,
    json,
  }));
}

function checkStatus({ status, json }) {
  if (status >= 200 && status < 300) {
    return json;
  }

  const errorObj = { status, json };

  throw errorObj;
}

export default function request(url, options) {
  return fetch(url, options)
    .then(parseJSON)
    .then(checkStatus);
}
